import React from "react";
import { useFormik } from "formik";

import {
  Tabs,
  Divider,
  Typography,
  Form,
  Row,
  Col,
  Input,
  Checkbox,
  Button,
  Table,
  message,
  Modal,
  Space,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import PageHeader from "../../../PageHeader";
import { hasAccess, objectToFormData } from "../../../../utils";
import {
  companySetting,
  updateCompanyAdvances,
  getAdvancesField,
  deleteAdvancesField,
  updateAdvancesField,
  UpdateCompanyAdvances,
  UpdateAdvancesField,
  DeleteAdvancesField,
  AddAdvancesField,
} from "../../../../actions/companySettings";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import "./../../styles/setting.css";
import "./../Custom.css";
import Text from "antd/lib/typography/Text";
import AddExpenseField from "./AddAdvancesField";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";

const { TabPane } = Tabs;
const { Title } = Typography;

const columns = [
  {
    title: "Field",
    dataIndex: "column_name",
    key: "column_name",
  },
  {
    title: "Column Type",
    dataIndex: "column_type",
    key: "column_type",
  },
];

message.config({
  maxCount: 3,
});

const Advances = () => {
  // const [activeTab, setActiveTab] = React.useState('profile');
  const dispatch = useDispatch();

  const [editMode, setEditMode] = React.useState(false);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [selectedId, setSelectedId] = React.useState("");
  const [advancesFields, setAdvancesFields] = React.useState([]);
  // const [companyValues, setCompanyValues] = React.useState({});
  const companySettingResponse = useSelector(
    (state) => state.companySetting.companySetting || {},
  );
  const updateCompanySettingResponse = useSelector(
    (state) => state.companySetting.updateCompanySetting || {},
  );
  const advancesFieldResponse = useSelector(
    (state) => state.companySetting.getAdvancesField || {},
  );
  const deleteAdvancesFieldResponse = useSelector(
    (state) => state.companySetting.deleteAdvancesField || {},
  );
  const addAdvancesFieldResponse = useSelector(
    (state) => state.companySetting.addAdvancesField || {},
  );
  const updateAdvancesFieldResponse = useSelector(
    (state) => state.companySetting.updateAdvancesField || {},
  );
  const updateAdvancesReportResponse = useSelector(
    (state) => state.companySetting.updateAdvancesReport || {},
  );
  const setTab = () => {};

  React.useEffect(() => {
    dispatch(companySetting({}));
    dispatch(getAdvancesField({}));
    // setIsModalVisible(false,);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { data: { response: { company_setting = {} } = {} } = {} } =
    companySettingResponse;

  React.useEffect(() => {
    formik.resetForm();
    const { data: { response: { company_setting = {} } = {} } = {} } =
      companySettingResponse;
    // setCompanyValues({...company_setting});
    formik.setValues({
      adv_amount_comments_pdf: company_setting.adv_amount_comments_pdf,
      adv_amount_history_pdf: company_setting.adv_amount_history_pdf,
      adv_amount_mandatory: company_setting.adv_amount_mandatory,
      adv_amount_receive_copy: company_setting.adv_amount_receive_copy,
      adv_amount_receive_email: company_setting.adv_amount_receive_email,
      adv_amount_reminder: company_setting.adv_amount_reminder,
      adv_amount_reminder_days: company_setting.adv_amount_reminder_days,
      adv_emp_details_pdf: company_setting.adv_emp_details_pdf,
      adv_include_logo_pdf: company_setting.adv_include_logo_pdf,
      adv_prefix: company_setting.adv_prefix,
      adv_starts_with: company_setting.adv_starts_with,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companySettingResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateCompanySettingResponse;
    if (status) {
      dispatch({
        type: UpdateCompanyAdvances.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: UpdateCompanyAdvances.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCompanySettingResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateAdvancesFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getAdvancesField({}));
      dispatch({
        type: UpdateAdvancesField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: UpdateAdvancesField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateAdvancesFieldResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      updateAdvancesReportResponse;
    if (status) {
      dispatch(companySetting({}));
      handleSubmit();

      dispatch({
        type: UpdateCompanyAdvances.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateAdvancesReportResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = deleteAdvancesFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getAdvancesField({}));
      dispatch({
        type: DeleteAdvancesField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: DeleteAdvancesField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteAdvancesFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = addAdvancesFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getAdvancesField({}));
      dispatch({
        type: AddAdvancesField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: AddAdvancesField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addAdvancesFieldResponse]);

  React.useEffect(() => {
    const { data: { response: { fields = [] } = {}, status = false } = {} } =
      advancesFieldResponse;
    if (status) {
      setAdvancesFields(fields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancesFieldResponse]);

  const tableAction = [
    {
      title: "Mandatory",
      dataIndex: "is_required",
      key: "is_required",
      render: (status, record) => (
        <Checkbox
          key={record.id}
          disabled={!hasAccess("advances_settings", "write")}
          onChange={(e) =>
            dispatch(
              updateAdvancesField(
                objectToFormData({ ...record, is_required: e.target.checked }),
              ),
            )
          }
          checked={status}
        ></Checkbox>
      ),
    },
    // {
    //   title: "Show in PDF",
    //   dataIndex: "view_in_pdf",
    //   key: "view_in_pdf",
    //   render: (status, record) =>
    //     <Checkbox key={record.id}
    //       disabled={!hasAccess("advances_settings", "write")}
    //       onChange={(e) => dispatch(updateAdvancesField(objectToFormData({ ...record, view_in_pdf: e.target.checked })))}
    //       checked={status}
    //     ></Checkbox>
    // },
    {
      title: "Enable",
      dataIndex: "is_enable",
      key: "is_enable",
      render: (status, record) => (
        <Checkbox
          key={record.id}
          disabled={!hasAccess("advances_settings", "write")}
          onChange={(e) =>
            dispatch(
              updateAdvancesField(
                objectToFormData({ ...record, is_enable: e.target.checked }),
              ),
            )
          }
          checked={status}
        ></Checkbox>
      ),
    },
    {
      title: "Actions",
      key: "action",
      render: (text, record) => (
        <Space key={record.id} size="middle">
          <button
            disabled={!hasAccess("advances_settings", "write")}
            onClick={() => showEditModal(record.id)}
          >
            <img src={EditIcon} alt={"logo"} className="action-logo" />
          </button>
          <button
            disabled={!hasAccess("advances_settings", "write")}
            onClick={() => showDeleteModal(record.id)}
          >
            <img src={DeleteIcon} alt={"logo"} className="action-logo" />
          </button>
        </Space>
      ),
    },
  ];

  const showModal = () => {
    setSelectedId("");
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("center");
  };

  const showEditModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const renderDeleteOption = () => {
    return (
      <>
        <Text>Are you sure you want to delete this field?</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() =>
            dispatch(deleteAdvancesField(objectToFormData({ id: selectedId })))
          }
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  const formik = useFormik({
    initialValues: {
      adv_starts_with: "",
      adv_prefix: "",
      adv_amount_reminder: "",
      adv_amount_reminder_days: "",
    },
    onSubmit: (values) => {
      const payload = {};
      [
        "adv_amount_comments_pdf",
        "adv_amount_history_pdf",
        "adv_amount_mandatory",
        "adv_amount_receive_copy",
        "adv_amount_receive_email",
        "adv_amount_reminder",
        "adv_amount_reminder_days",
        "adv_emp_details_pdf",
        "adv_include_logo_pdf",
        "adv_prefix",
        "adv_starts_with",
      ].forEach((item) => {
        payload[item] = values[item];
      });

      dispatch(updateCompanyAdvances(objectToFormData({ ...payload })));
    },
  });

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleSubmit = () => {
    setEditMode(false);
  };

  return (
    <>
      <Modal
        title={
          modalType === "center" ? (
            <>
              <img src={DeleteIcon} alt={"logo"} className="action-logo" />{" "}
              Delete Field
            </>
          ) : (
            <Title level={4}>
              {selectedId ? "Edit Fields" : "Add Fields"} &nbsp;
              <span className="text-small">Enter details and submit</span>
            </Title>
          )
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className={
          modalType === "center"
            ? "center-aligned-modal"
            : "right-alinged-modal-small"
        }
      >
        {modalType === "center" ? (
          renderDeleteOption()
        ) : (
          <AddExpenseField id={selectedId} handleCancel={handleCancel} />
        )}
      </Modal>
      <div className="heading-div">
        <PageHeader
          title={`Advances`}
          navigation={{
            Home: "/dashboard/",

            Customisation: "/setting/customisation/",
            Advances: null,
          }}
        />
      </div>
      <Tabs onChange={setTab} type="card" size="large" className="custom-tabs">
        <TabPane tab="Preferences" key="preferences">
          <div className="tabContentWrapper">
            <Title level={5}>Auto-generate Advance ID</Title>
            <Divider />
            <Form
              layout="vertical"
              className="custom-form"
              onFinish={formik.handleSubmit}
              // validateMessages={validateMessages1}
            >
              <Row>
                <Col span={8}>
                  <Form.Item label="Prefix">
                    <Input
                      name="adv_prefix"
                      placeholder=""
                      value={formik.values.adv_prefix}
                      onChange={formik.handleChange}
                      disabled={!editMode || company_setting.adv_prefix}
                      //   disabled={company_setting.adv_prefix}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} className="ml1">
                  <Form.Item label="Start with">
                    <Input
                      name="adv_starts_with"
                      placeholder=""
                      value={formik.values.adv_starts_with}
                      //onChange={formik.handleChange}
                      onChange={(e) => {
                        if (Number.isNaN(Number(e.target.value))) {
                          return;
                        }
                        formik.setFieldValue("adv_starts_with", e.target.value);
                      }}
                      disabled={!editMode || company_setting.adv_starts_with}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* <Title level={5} className="customTitle">
                        PDF Options
                    </Title>
                    <Divider />
                    <Row>
                        <Col span={24}>
                            <Form.Item name="adv_emp_details_pdf" valuePropName="checked">
                                <Checkbox>Show Employee Details in PDF</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="adv_amount_history_pdf" valuePropName="checked">
                                <Checkbox>Show advance amount history in PDF</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="adv_amount_comments_pdf" valuePropName="checked">
                                <Checkbox>Show advance amount comments in PDF</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="adv_include_logo_pdf" valuePropName="checked">
                                <Checkbox>Include company logo in PDF</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row> */}

              <Title level={5} className="customTitle">
                Notifications
              </Title>
              <Divider />
              <Row>
                <Col span={24}>
                  <Form.Item
                    valuePropName="checked"
                    style={{ marginBottom: "0px" }}
                  >
                    <Checkbox
                      checked={formik.values.adv_amount_reminder}
                      disabled={!editMode}
                      name="adv_amount_reminder"
                      onChange={(e) => {
                        formik.setFieldValue(
                          "adv_amount_reminder",
                          e.target.checked,
                        );
                      }}
                    >
                      <span className="flexDisplay">
                        Reminder alert to employees if the advance amount is
                        pending for more than &nbsp;
                        <Form.Item className="shortNumberInput">
                          <Input
                            className="shortInput"
                            name="adv_amount_reminder_days"
                            disabled={!editMode}
                            onChange={(e) => {
                              if (Number.isNaN(Number(e.target.value))) {
                                return;
                              }
                              formik.setFieldValue(
                                "adv_amount_reminder_days",
                                e.target.value,
                              );
                            }}
                            value={formik.values.adv_amount_reminder_days}
                          />
                        </Form.Item>{" "}
                        &nbsp;days for submission
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

              {/* <Title level={5} className="customTitle">
                      Settings
                    </Title>
                    <Divider />
                    <Row>
                        <Col span={24}>
                            <Form.Item name="adv_amount_mandatory" valuePropName="checked">
                                <Checkbox>Apply advance amount mandatory in expense report</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="adv_amount_receive_copy" valuePropName="checked">
                                <Checkbox>Receive a copy of the Advance Amount</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={9}>
                          <Form.Item name="adv_amount_receive_email" >
                                <Input placeholder="Select or type to add email address" />
                            </Form.Item>
                        </Col>
                    </Row>
                     */}
              {!editMode && hasAccess("advances_settings", "write") && (
                <Button
                  type="button"
                  className="formButton mt3"
                  onClick={() => handleEdit()}
                >
                  Edit
                </Button>
              )}
              {editMode && (
                <Button key="5" className="formButton mt3" htmlType="submit">
                  Save
                </Button>
              )}
              {/* <Button key="6" className="cancelButton ml1 mt3" onClick={() => history.push(RouteConstants.SETTING_USERS)}></Button> */}
            </Form>
          </div>
        </TabPane>
        <TabPane tab="Fields" key="fields">
          <div className="tabContentWrapper">
            {hasAccess("advances_settings", "write") && (
              <Button onClick={showModal} className="mb1 addNew">
                <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />
                New Field
              </Button>
            )}
            <Table
              rowKey="id"
              columns={[...columns, ...tableAction]}
              dataSource={advancesFields}
              className="settingsTable"
            />
          </div>
        </TabPane>
      </Tabs>
    </>
  );
};

export default Advances;
